"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useShadePickerEvent = void 0;
var BasketUpdated = _interopRequireWildcard(require("@ori-events/basket-updated"));
var OpenShadePicker = _interopRequireWildcard(require("@ori-events/open-shade-picker"));
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _utils = require("../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useShadePickerEvent = () => {
  const [shadePickerData, setShadePickerData] = (0, _react.useState)(null);
  const {
    initialOpenDone,
    open,
    onClose,
    onOpen
  } = (0, _presentationHooks.useInitialDisclose)();
  const onOpenShadePicker = (0, _react.useCallback)(({
    detail: {
      productName,
      products,
      placement,
      goToUrl,
      productCode,
      mode
    }
  }) => {
    setShadePickerData({
      mode,
      productName,
      products,
      placement,
      productCode,
      goToUrl: goToUrl ?? (0, _utils.getProductUrl)(productCode)
    });
    onOpen();
  }, [onOpen]);
  const onCloseShadePicker = (0, _react.useCallback)(() => {
    setShadePickerData(null);
    onClose();
  }, [onClose]);
  const events = (0, _react.useMemo)(() => [{
    name: OpenShadePicker.Name,
    listener: onOpenShadePicker
  }, {
    name: BasketUpdated.Name,
    listener: onCloseShadePicker
  }], [onCloseShadePicker, onOpenShadePicker]);
  (0, _presentationHooks.useGlobalEvents)(events);
  return {
    data: shadePickerData,
    initialOpenDone,
    onClose,
    open
  };
};
exports.useShadePickerEvent = useShadePickerEvent;
